module.exports = [
  {
    "AgeGroup": "15-24 years",
    "Geography": "Metro New Orleans",
    "Year": "1999-2001",
    "Rate": 128.43
  },
  {
    "AgeGroup": "15-24 years",
    "Geography": "Metro New Orleans",
    "Year": "2002-2004",
    "Rate": 153.87
  },
  {
    "AgeGroup": "15-24 years",
    "Geography": "Metro New Orleans",
    "Year": "2005-2007",
    "Rate": 165.03
  },
  {
    "AgeGroup": "15-24 years",
    "Geography": "Metro New Orleans",
    "Year": "2008-2010",
    "Rate": 135.47
  },
  {
    "AgeGroup": "15-24 years",
    "Geography": "Metro New Orleans",
    "Year": "2011-2013",
    "Rate": 131.37
  },
  {
    "AgeGroup": "15-24 years",
    "Geography": "Metro New Orleans",
    "Year": "2014-2016",
    "Rate": 112.73
  },
  {
    "AgeGroup": "15-24 years",
    "Geography": "Metro New Orleans",
    "Year": "2017-2018",
    "Rate": 116.9
  },
  {
    "AgeGroup": "15-24 years",
    "Geography": "United States",
    "Year": "1999-2001",
    "Rate": 79.8
  },
  {
    "AgeGroup": "15-24 years",
    "Geography": "United States",
    "Year": "2002-2004",
    "Rate": 80.57
  },
  {
    "AgeGroup": "15-24 years",
    "Geography": "United States",
    "Year": "2005-2007",
    "Rate": 80.3
  },
  {
    "AgeGroup": "15-24 years",
    "Geography": "United States",
    "Year": "2008-2010",
    "Rate": 70.57
  },
  {
    "AgeGroup": "15-24 years",
    "Geography": "United States",
    "Year": "2011-2013",
    "Rate": 66.3
  },
  {
    "AgeGroup": "15-24 years",
    "Geography": "United States",
    "Year": "2014-2016",
    "Rate": 69.97
  },
  {
    "AgeGroup": "15-24 years",
    "Geography": "United States",
    "Year": "2017-2018",
    "Rate": 72.1
  }
]
